<template>
    <div class="sub-tit">
        <h2>주차</h2>
    </div>
    <div class="tab-menu type02">
        <ul class="tab-menu__list">
            <li class="tab-menu__item on"><a href="/park/parkIntro.do" type="button" class="tab-menu__btn">창원파티마병원 주차등록</a></li>
        </ul>
    </div>
    <div class="parkingRes_wrap">
        <div class="join-tab">
            <ul class="join-tab__list">
                <li class="join-tab__item active">
                    <div class="tit">창원파티마병원 주차등록 확인</div>
                </li>
            </ul>
        </div>

        <div class="certification">
            <ul class="contents login-box__list">
                <li class="login-box__item">
                    <h3 class="tit" style="color: #333;">차량을 선택한 후 
                        <span style="color:rgb(203 168 20);">확인</span> 버튼을 눌러주세요.
                    </h3>
                    
                   
                    <div class="parking_info_wrap">
                        <ul class="parking_info_list">
                            <li class="parking_info_txt">
                                <div class="parking_txt_wrap">
                                    <button 
                                        v-for="(item, idx) in parkingList" 
                                        :key="idx"
                                        :class="{ active: activeIndex === idx }"
                                        @click="toggleActive(idx)"
                                        >
                                        <span>{{ item.car }}</span>
                                    </button>
                                </div>
                            </li>
                        </ul>
                        <div class="parking_confrim_btn_wrap">
                            <a href="/park/parkForm.do" class="parking_confrim_btn">이전</a>
                            <a href="/park/parkIntro.do" class="parking_confrim_btn">취소</a>
                            <!-- <a href="/park/parkCheck.do" class="parking_confrim_btn" style="color:rgb(203 168 20);">확인</a> -->
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
const SS_KEY = 'park:list';

export default {
    data() {
       return {
            activeIndex: null,
            parkingList: [
                { car: "111가 1234", time: "2025-09-07 10:30" },
                { car: "333나 7777", time: "2025-09-07 11:00" },
                { car: "444다 7777", time: "2025-09-07 11:00" },
                { car: "555라 7777", time: "2025-09-07 11:00" },
                { car: "333나 7777", time: "2025-09-07 11:00" },
                { car: "333나 7777", time: "2025-09-07 11:00" },
                { car: "333나 7777", time: "2025-09-07 11:00" },
                { car: "333나 7777", time: "2025-09-07 11:00" },
                { car: "333나 7777", time: "2025-09-07 11:00" },
                { car: "333나 7777", time: "2025-09-07 11:00" }
            ]
        }
    },
    mounted() {
        const list = history.state?.list || [];
        this.parkingList = (Array.isArray(list) ? list : []).map(v => ({ car: v, time: '' }));
    },

    methods: {
        today() {
            const d = new Date();
            const mm = String(d.getMonth() + 1).padStart(2, "0");
            const dd = String(d.getDate()).padStart(2, "0");
            return `${d.getFullYear()}${mm}${dd}`;
        },

        toggleActive(idx) {
            this.activeIndex = this.activeIndex === idx ? null : idx;
            if (this.activeIndex === null) return;

            const carnoRaw = this.parkingList[idx]?.car || "";
            const carno = carnoRaw.replace(/\s/g, ""); // 공백 제거(필요 시)
            this.registerCar(carno);
        },
        
        registerCar(carno) {
        // 필수 파라미터 준비
        const payload = {
            carno,                // 차량번호 (예: "111가1234")
            insdd: this.today(), // 등록일(yyyyMMdd)
            discntcd: "M",        // 할인구분코드(요구사항에 맞게 고정/선택)
            macaddr: ""           // 필요 없으면 빈 문자열
        };

        this.axios.post(this.api.park.reg, payload)
            .then(({ data }) => {
            // 컨트롤러는 Map<String,Object> 그대로 반환
            // park 연동 응답 형태에 맞춰 메시지 추출 시도
            const msg =
                data?.message?.msg ||
                data?.temp?.message?.msg || // (혹시 XML -> Map이 이런 형태라면)
                "정상적으로 처리되었습니다.";

            
                alert(`${msg}\n입차시간으로부터 2시간 무료 주차 가능합니다.`);
                // 필요 시 다른 페이지로 이동하거나 상태 초기화
                this.$router.push('/park/parkForm.do');
            })
            .catch(err => {
                console.error(err);
            alert("차량 등록 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.");
            });
        },
    },
}
</script>